import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Typography, Link } from '@mui/material'

import { mainConfig } from '../../config'

import styles from './styles'

const useStyles = makeStyles(styles)

const Footer = () => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Grid container item xs={12}>
        <Box width="100%" textAlign="center">
          <Typography variant="caption">
            Copyright © 2022 Coherus BioSciences -{' '}
            <Link
              href="https://github.com/dogtownmedia/coherus-optin-mailing-list/tags"
              underline="hover"
            >
              Version {mainConfig.appVersion.split('/').pop()}
            </Link>
          </Typography>
        </Box>
      </Grid>
    </Box>
  )
}

export default memo(Footer)
